import { getAuthInstance, useUser } from '@taki/auth';
import { FournisseurDeBrouillons } from '@taki/ui';
import type { JSX, ReactNode } from 'react';

/**
 * LES BROUILLONS DE LA PERSONNE CONNECTEE : un seul magasin au-dessus des apps
 * ET du centre, pour qu'un canal ait le meme brouillon partout. Il change avec
 * la personne (`uid`) et l'organisation : un autre compte du poste ne voit rien.
 * Le compte courant du client Auth sert de repli a la premiere image, avant que
 * `useUser` n'ait repondu : le magasin ne change alors pas sous les surfaces.
 */
export function BrouillonsDuCompte({ orgId, children }: { orgId: string; children: ReactNode }): JSX.Element {
  const { user } = useUser();
  const uid = user?.uid ?? getAuthInstance()?.currentUser?.uid ?? null;
  return <FournisseurDeBrouillons orgId={orgId} uid={uid}>{children}</FournisseurDeBrouillons>;
}
